"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pDefer = _interopRequireDefault(require("./external/p-defer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EventAsPromise =
/*#__PURE__*/
function () {
  function EventAsPromise() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventAsPromise);

    this.defers = [];
    this.upcomingDeferred = null;
    this.eventListener = this.eventListener.bind(this);
    this.options = options;
    this.one = this.one.bind(this);
    this.upcoming = this.upcoming.bind(this);

    this[Symbol.iterator] = function () {
      return {
        next: function next() {
          return {
            done: false,
            value: _this.upcoming()
          };
        }
      };
    };
  }

  _createClass(EventAsPromise, [{
    key: "eventListener",
    value: function eventListener(event) {
      var deferred = this.defers.shift();
      var args = this.options.array ? [].slice.call(arguments) : event;
      deferred && deferred.resolve(args);

      if (this.upcomingDeferred) {
        this.upcomingDeferred.resolve(args);
        this.upcomingDeferred = null;
      }
    }
  }, {
    key: "one",
    value: function one() {
      var deferred = (0, _pDefer.default)();
      this.defers.push(deferred);
      return deferred.promise;
    }
  }, {
    key: "upcoming",
    value: function upcoming() {
      if (!this.upcomingDeferred) {
        this.upcomingDeferred = (0, _pDefer.default)();
      }

      return this.upcomingDeferred.promise;
    }
  }]);

  return EventAsPromise;
}();

exports.default = EventAsPromise;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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